import { Flex, Text } from '@mantine/core'

import { getCurrencyInfo } from '@/configs/currencies'
import { useSsrContext } from '@/contexts/ssr'

import styles from './index.module.css'

const items = ['50', '150', '500']
export default function MoneyItems({
  setCurrencyValue,
}: {
  setCurrencyValue: (currencyValue: string) => void
}) {
  const { selectedCurrency } = useSsrContext()
  const currency = getCurrencyInfo(selectedCurrency)
  const symbol = currency?.symbol ?? '$'
  return (
    <Flex>
      {items.map(value => (
        <Flex key={value} className={styles.moneyItem} onClick={() => setCurrencyValue(value)}>
          <Text variant={'subtitle-emphasis'} c={'var(--content-active-bold)'}>
            {symbol}
            {value}
          </Text>
        </Flex>
      ))}
    </Flex>
  )
}
